export default "__VITE_ASSET__59cb5883__"